/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable indent */
import styled from "styled-components";
import { Container, Row, Columns, Section } from "../../styles/commonStyles";
import media, { mediaMaxWidth } from "../../utils/mediaQuery";
import CircleWithLine from "../../assets/svgs/CircleWithLine";
import StatJobsIcon from "../../assets/svgs/StatJobsIcon";
import StatUserIcon from "../../assets/svgs/StatUserIcon";

const StatsBanner = () => (
	<SectionContainer bgColor="#4d3951">
		<Container>
			<Wrapper>
				<RowWrapper>
					<StatsCard
						title="Users"
						icon={<StatUserIcon />}
						stats={
							<h2>
								5 Crore+ <span id="blue-text">Users</span>
							</h2>
						}
						color="#ffd166"
					/>
				</RowWrapper>
				<RowWrapper>
					<StatsCard
						title="Jobs"
						icon={<StatJobsIcon />}
						stats={
							<h2>
								50 Lakh+ <span id="yellow-text">Jobs</span>
							</h2>
						}
						color="#83bde4"
					/>
				</RowWrapper>
			</Wrapper>
		</Container>
		<BackgroundShapeContainer>
			<CircleWithLine />
		</BackgroundShapeContainer>
	</SectionContainer>
);

const StatsCard = ({ title, icon, stats }) => (
	<StatsCardContainer title={title}>
		<StatsIconContainer>{icon}</StatsIconContainer>
		<StatsTextContainer>
			<StatsCountContainer>
				<Stats>{stats}</Stats>
			</StatsCountContainer>
		</StatsTextContainer>
	</StatsCardContainer>
);

// Styles
const Stats = styled.div`
	min-width: 330px;

	h2 {
		font-size: 60px;
		font-weight: 900;
		color: #ffffff;
		margin-bottom: 0;
	}

	span#yellow-text {
		color: #ffd166;
	}

	span#blue-text {
		color: #83bde4;
	}

	${mediaMaxWidth.medium`
        min-width: 130px;

		h3 {
			font-size: 50px;
		}
    `}
	${mediaMaxWidth.extraSmall`
		min-width: auto;
    `}

	${mediaMaxWidth.extraExtraSmall`
		h3 {
			font-size: 40px;
		}
	`}
`;

const StatsIconContainer = styled.div`
	margin-right: 40px;
	padding-bottom: 45px;
	${mediaMaxWidth.medium`
		margin-right: 30px;
        & svg { 
            width: 64px;
            height: 64px;
        }
    `}
`;
const StatsCountContainer = styled.div`
	margin-right: 40px;
	${mediaMaxWidth.extraSmall`
		margin-right: 10px;
    `}

	${media.medium`
		margin-right: 0;
    `}
`;

const StatsCardContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-start;

	${mediaMaxWidth.small`
		justify-content: flex-start;
		margin: 0;
	`}
`;
const StatsTextContainer = styled(StatsCardContainer)`
	padding-bottom: 50px;
`;
const RowWrapper = styled(Row)`
	justify-content: flex-start;
	padding: 50px 0 0;
	max-width: 1070px;
	margin: 0 auto;

	${media.small`
		min-width: 495px;
	`}
	/* ${mediaMaxWidth.large`
        flex-wrap: wrap;

        & ${Columns}:not(:first-child) {
            margin-top: 50px;
        }

        & ${Columns}::after {
            display: none;
        }
    `}; */
	${mediaMaxWidth.small`
		justify-content: flex-start;
	`}
`;
const SectionContainer = styled(Section)`
	position: relative;
	padding-top: 50px;
	overflow: hidden;

	& ${Columns} {
		position: relative;
	}

	& ${Columns}:not(:last-child)::after {
		content: "";
		position: absolute;
		top: 50%;
		right: 0;
		width: 8px;
		height: 8px;
		background-color: #ffd166;
		border-radius: 50%;
	}

	& ${RowWrapper}:not(:last-child) {
		& ${StatsTextContainer} {
			/* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
		}
	}

	${mediaMaxWidth.medium`
        & ${StatsTextContainer} {
            min-width: auto;
        }
    `};
`;

const BackgroundShapeContainer = styled.div`
	width: 206px;
	height: 206px;
	position: absolute;
	top: 30%;
	left: -90px;
	transform: scale(1.5) rotate(35deg);
	opacity: 0.1;
	mix-blend-mode: screen;

	${mediaMaxWidth.medium`
        top: 19%;
    `};
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	${media.extraLarge`
		flex-direction: row;
        display: flex;
    `};
`;

export default StatsBanner;
